<div class="rounded-xl overflow-hidden shadow-lg">

    <!-- Header -->
    <div class="flex items-center justify-center dialog-header">
        Delete Admission
        <div class="absolute right-4">
            <button (click)="handleCloseDialog()" class="text-white hover:text-gray-300">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="dialog-content p-6 text-center">
        <!-- Trash Icon -->
        <i class="pi pi-trash text-16xl text-gray-600 mb-4" style="font-size: 27px;"></i>

        <!-- Title -->
        <div class="font-semibold text-xl mb-2">
            Are you Sure you want to Delete the Admission?
        </div>

        <!-- Admission Info -->
        <div class="text-gray-600">
            Admission Number - {{ editLeadData?.admission_number || 'N/A' }} <br />
            Contact Name - {{ getFullName(editLeadData) }}
        </div>

        <!-- Buttons -->
        <div class="flex gap-4 mt-7 justify-center">
            <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()">
            </p-button>

            <p-button label="Delete" icon="pi pi-trash" (click)="handleDelete()" [disabled]="isLoading"
                [loading]="isLoading">
            </p-button>
        </div>
    </div>
</div>